/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1noh358{row-gap:var(--spacingVerticalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkhj508{font-size:var(--fontSizeBase300);}
.fkfq4zb{color:var(--colorNeutralForeground2);}
/** @griffel:css-end **/